export default class {
    value: any;

    // Will contain previous values, with the most recent at the beginning of the array
    history: any[] = [];

    // Will contain which previous value we rolled back to. 0 means we have not rolled back
    historyIndex: number = 0;

    constructor(value: any) {
        this.value = JSON.parse(JSON.stringify(value));
        this.save();
    }

    save() {
        if (this.historyIndex > 0) {
            this.history.splice(0, this.historyIndex);
        }

        this.history.unshift(JSON.parse(JSON.stringify(this.value)));
        this.historyIndex = 0;
    }

    canUndo() {
        return this.history.length > 1 && this.historyIndex < this.history.length - 1;
    }

    canRedo() {
        return this.historyIndex > 0;
    }

    undo() {
        if (!this.canUndo()) {
            return;
        }

        this.value = this.history[++this.historyIndex];
    }

    redo() {
        if (!this.canRedo()) {
            return;
        }

        this.value = this.history[--this.historyIndex];
    }

    clear() {
        this.history.splice(1);
        this.historyIndex = 0;
    }
}
